import type { IQueueEvent } from "../types";

/**
 * Returns the time of the event in seconds
 * @param event - The event to get the time of
 * @returns The time of the event in seconds
 */
export function eventTime(event: IQueueEvent): number {
  /*
   * If the event doesn't have a metric, it means it's a empty tagged event.
   * In this case, serverTime will hold the Date.now() value from when the event was tagged.
   */
  if (event.noMetricEvent) {
    return event.serverTime;
  }

  return (
    event.pitch_data?.PlateEpochSeconds ??
    event.hit_data?.ExitEpochSeconds ??
    -1
  );
}
